import { useEffect } from 'react';

// Closes a popover when a click lands outside both the popover and its trigger.
// Bound on the document in the bubble phase, matching the original behaviour:
// the trigger's own handler runs first and stops propagation to toggle instead.
export function useOutsideClick(active, refs, onOutside) {
  useEffect(() => {
    if (!active) return undefined;
    function handle(event) {
      const inside = refs.some((ref) => ref.current && ref.current.contains(event.target));
      if (!inside) onOutside();
    }
    document.addEventListener('click', handle);
    return () => document.removeEventListener('click', handle);
    // refs is a stable-length array of refs; spreading it keeps the dep list honest
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, onOutside, ...refs]);
}
